/* eslint-disable camelcase */
import map from "lodash/fp/map";
import find from "lodash/fp/find";
import assign from "lodash/fp/assign";
import isNil from "lodash/fp/isNil";
import isObject from "lodash/fp/isObject";
import findIndex from "lodash/fp/findIndex";
import forIn from "lodash/fp/forIn";
import has from "lodash/fp/has";
import {
  toObject,
  getTime,
  multiplyFloatingPointByCurrency,
  extractEnvNameAndAppendToMarketplace,
} from "../../core/utils";
import moment from "moment";
import constants from "../../core/constants";
import conflictingDialogCtrl from "../conflictingDialog/conflictingDialog.controller";
import conflictingDialog from "../conflictingDialog/conflictingDialog.html";
import first from "lodash/fp/first";
class Controller {
  constructor(Events, $mdDialog, $injector, $stateParams) {
    "ngInject";

    this.Events = Events;
    this.$injector = $injector;
    this.$mdDialog = $mdDialog;
    this.$stateParams = $stateParams;
    this.currentDate = moment().startOf("day");
    this.Lists = $injector.get("Lists").all;
    this.Schedule = $injector.get("Schedule");
    this.Reservation = $injector.get("Reservation");
    this.Messages = $injector.get("Messages");
    this.Contracts = $injector.get("Contracts");
    this.City = $injector.get("City");
    this.BoardingCheckin = $injector.get("BoardingCheckin");

    this.RouteTransforms = $injector.get("RouteTransforms");
    this.reverseJustifySchedule = $injector.get(
      "RouteTransforms"
    ).reverseJustifySchedule;
    this.onUpdateTimeEvent = Events.getUpdateEvent("scheduleTime");
    this.onUpdateLabelEvent = Events.getUpdateEvent("scheduleLabel");
    this.onUpdateActiveEvent = Events.getUpdateEvent("scheduleActive");

    this.onUpdateBookOnTheFlyEvent = Events.getUpdateEvent(
      "scheduleAllowBookOnTheFly"
    );
    this.onUpdateCaptainEvent = Events.getUpdateEvent("scheduleCaptain");
    this.onUpdateBustypeEvent = Events.getUpdateEvent("scheduleBustype");
    this.onUpdateCaptainPriceEvent = Events.getUpdateEvent(
      "scheduleCaptainPrice"
    );
    this.onUpdateScheduleBufferEvent = Events.getUpdateEvent("scheduleBuffer");
    this.onUpdateArrivalAllowanceEvent = Events.getUpdateEvent(
      "scheduleArrivalAllowance"
    );
    this.onUpdateDepartureAllowanceEvent = Events.getUpdateEvent(
      "scheduleDepartureAllowance"
    );
    this.onChangeBusTypeEvent = Events.getUpdateEvent("changeBusType");
    this.onChangeRideCategoryEvent = Events.getUpdateEvent(
      "changeRideCategory"
    );
    this.onChangeCorporateEvent = Events.getUpdateEvent("changeCorporate");
    this.onUpdatePricingConf = Events.getUpdateEvent(
      "updatePricingConfSchedules"
    );
    this.onResetPricingConf = Events.getUpdateEvent("resetPricingConf");
    this.onFollowCityForNewSchedules = Events.getUpdateEvent("followCity");
    this.routeScheduleEvent = this.Events.getUpdateEvent("routeSchedule");
    this.onAddScheduleEvent = this.Events.eventsType.onScheduleSave;
    this.showNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
  }

  $onInit() {
    // Get ride Category
    this.City.getRideCategory({ city: this.route.city._id }).$promise.then(
      (response) => {
        this.rideCategoryList = response.hits;
        this.rideCategoryList.forEach((item) => {
          item.ride_type = item._source.ride_type;
          item.title = `${item._source.ride_type} ${item._source.service_type}`;
        });
      },
      (response) => {
        this.Events.emit(this.errorEvent, response.data);
      }
    );
    this.showConflictDialog = (captainConflict) => {
      const timezone = this.route.city.timezone;
      this.$mdDialog.show({
        controller: conflictingDialogCtrl,
        controllerAs: "$ctrl",
        template: conflictingDialog,
        locals: {
          captainConflict,
          timezone,
        },
      });
    };
    this.marketplacePlanURL = `${extractEnvNameAndAppendToMarketplace()}plans/`;
    const removeSource = (item) => assign({ _id: item._id }, item._source);
    const getWeekedays = (weekdays) => {
      const selected = [];

      weekdays.forEach((day) => {
        if (day.isSelected) selected.push(day.value);
      });

      return selected;
    };

    const confirm = this.$mdDialog
      .confirm()
      .title("Are you sure you want to remove this schedule?")
      .textContent("If you chose to remove it you can add it again.")
      .ok("Remove")
      .cancel("Cancel");

    this.isObject = (item) => isObject(item) || typeof item === "undefined";
    this.onAutoCompleteSearch = (text, resource) => {
      const request = this.$injector.get(resource).search(text);
      return request.$promise.then((list) => map(removeSource)(list.hits));
    };

    this.addSchedule = () => {
      const scheduleWeekDays = this.Lists.weekDays.map((x) =>
        Object.assign({}, x)
      );
      const newItem = toObject(
        {
          time: moment(),
          captain: {},
          scheduleWeekDays,
          bus_type: {},
          captain_price: {},
          active: false,
          is_manual_eta: false,
          ride_booking_method: false,
          label: {},
          schedule_buffer: {},
          corporate: {},
          ride_price: {
            isDisabled: true,
            value: "N/A",
          },
          supply_cost: {
            isDisabled: true,
            value: "Captain Plan",
          },
          ride_category: {},
          pricing_parameters: {},
          manual_estimates: [],
          isManualEstimatesEditable: true,
        },
        true
      );

      this.schedules.unshift(
        Object.assign({}, newItem, {
          index: this.schedules.length,
          hideEdit: true,
        })
      );
    };

    this.reflectSchedule = (schedule) => {
      this.Events.emit(this.reflectEvent, schedule);
    };

    this.removeSchedule = (schedule, index) => {
      if (schedule.time && schedule.bus_type.name) {
        this.$mdDialog.show(confirm).then(
          () => {
            this.Events.emit(this.deleteEvent, schedule, index);
          },
          () => {}
        );
      } else {
        this.schedules.splice(index, 1);
      }
    };

    this.clearCaptain = (index) => {
      this.schedules[index].captain = null;
    };

    this.onUpdateWeekdays = (day, scheduleIndex, weekdayIndex) => {
      this.schedules[scheduleIndex].isWeekDaysChanged = true;
      this.schedules[scheduleIndex].scheduleWeekDays[
        weekdayIndex
      ].isSelected = !day.isSelected;
    };

    this.onChangeCorporate = ({ value, extraParams: schedule }) => {
      const corporate = value.name;
      // Check for value isDisabled to handle corporate value initialization
      if (schedule && schedule.pricingVersionValue === "fixed") {
        if (!isNil(corporate) && !isNil(corporate._id)) {
          this.Contracts.getActive({
            corporateId: corporate._id,
          })
            .$promise.then((response) => {
              schedule.active_contract = response;
              if (!value.isDisabled) this.applyRidePrice(schedule);
            })
            .catch(() => {
              schedule.active_contract = null;
              if (!value.isDisabled) this.applyRidePrice(schedule);
            });
        } else {
          schedule.active_contract = null;
          if (!value.isDisabled) this.applyRidePrice(schedule);
        }
      }

      if (corporate._id) {
        this.BoardingCheckin.getConfig(
          "Corporate",
          corporate._id
        ).$promise.then((response) => {
          if (response) {
            schedule.is_list_allowed = response.is_list_allowed;
            schedule.is_qr_code_allowed = response.is_qr_code_allowed;
          }
        });
      }
    };

    this.onChangeBusType = ({ value, extraParams: schedule }) => {
      const busType = value.name;
      if (schedule && schedule.pricingVersionValue === "fixed") {
        this.applyRidePrice(schedule, busType);
      }
    };

    this.onChangeRideCategory = ({ value, extraParams: schedule }) => {
      const getRideCategory = (l) => l._id === value._id;
      const ride_category = find(getRideCategory)(this.rideCategoryList);
      this.newScheduleRideType = isNil(ride_category)
        ? undefined
        : ride_category.ride_type;
      value.ride_type = this.newScheduleRideType;
      const selectedCategoryDetails = this.route.city.ride_categories.find(
        (categoryItem) => categoryItem.category === value._id
      );
      this.cityCategoryPricing = selectedCategoryDetails.features.find(
        (feature) => feature.name === "pricing_version"
      );
      // Dynamic represent non-business schedules
      if (
        !isNil(this.cityCategoryPricing) &&
        this.cityCategoryPricing.value === "dynamic"
      ) {
        schedule.noPricingConfig = false;
        schedule.pricingVersionValue = "dynamic";
        schedule.pricing_parameters = { ...this.cityCategoryPricing.config };
        schedule.pricing_parameters.base_fare /= constants.currencyBy;
        schedule.pricing_parameters.maximum_fare /= constants.currencyBy;
        schedule.pricing_parameters.time_bucket_fare /= constants.currencyBy;
        schedule.pricing_parameters.distance_bucket_fare /=
          constants.currencyBy;
        delete schedule.is_list_allowed;
        delete schedule.is_qr_code_allowed;
      } else {
        // Fixed represent business schedules
        schedule.pricingVersionValue = "fixed";
        schedule.noPricingConfig = true;
      }
    };

    this.getContractPricing = (schedule, busType) => {
      const ridePrice = schedule.active_contract.subscriptions.find((sub) => {
        const contractType = schedule.active_contract.contract_type;
        if (contractType === "busType" || contractType === "lumpsum") {
          return sub.bus_type._id === busType._id;
        }
        return (
          sub.bus_type._id === busType._id &&
          sub.route._id === this.route._id.value
        );
      });
      return ridePrice;
    };

    this.applyRidePrice = (schedule, newBusType) => {
      const busType =
        newBusType || (schedule.bus_type && schedule.bus_type.name);
      if (
        !isNil(this.route) &&
        !isNil(schedule.active_contract) &&
        !isNil(busType)
      ) {
        const contractPricing = this.getContractPricing(schedule, busType);
        if (isNil(contractPricing)) {
          schedule.ride_price.value = "N/A";
          schedule.supply_cost.value = "Captain Plan";
        } else {
          const {
            ride_price: ridePrice,
            captain_price: supplyCost,
          } = contractPricing.pricing;
          schedule.ride_price.value = ridePrice
            ? ridePrice / constants.currencyBy
            : "N/A";
          schedule.supply_cost.value = supplyCost
            ? supplyCost / constants.currencyBy
            : "Captain Plan";
        }
      } else {
        schedule.ride_price = {
          isDisabled: true,
          value: "N/A",
        };
        schedule.supply_cost = {
          isDisabled: true,
          value: "Captain Plan",
        };
      }
    };
    this.onSaveWeekdays = (scheduleIndex) => {
      const weekDays = getWeekedays(
        this.schedules[scheduleIndex].scheduleWeekDays
      );
      const id = this.schedules[scheduleIndex]._id.value;
      const name = "update_weekdays";
      const param = Object.assign({}, { weekdays: weekDays });

      this.onUpdateItem(id, name, param).then(
        () => {
          this.Events.emit(
            this.showNotificationEvent,
            this.Messages.updateMessage("stations")
          );
          this.schedules[scheduleIndex].isWeekDaysChanged = false;
        },
        (response) => {
          if (response.data.captainConflict) {
            const captainConflict = response.data.captainConflict;
            this.showConflictDialog(captainConflict);
          }
          this.Events.emit(this.errorEvent, response.data);
        }
      );
    };

    this.saveSchedule = (newschedule, index) => {
      // Validate corporate reservation
      const justifiedSchedule = this.reverseJustifySchedule(newschedule);
      // Check if corporate is selected
      if (
        newschedule.pricingVersionValue === "fixed" &&
        isNil(justifiedSchedule.corporate)
      ) {
        const message = "Missing corporate reservations fields";
        this.Events.emit(this.errorEvent, { message });
        return;
      }

      // Add corporate reservation
      let corporateReservations;
      if (
        !isNil(justifiedSchedule.corporate) &&
        !isNil(justifiedSchedule.supply_cost) &&
        !isNil(justifiedSchedule.ride_price)
      ) {
        corporateReservations = {
          corporate: justifiedSchedule.corporate,
          ride_price: justifiedSchedule.ride_price,
          supply_cost: justifiedSchedule.supply_cost,
        };
      }

      // Requested schedule
      if (
        newschedule.bus_type &&
        newschedule.time &&
        newschedule.ride_category
      ) {
        const time = getTime(newschedule.time.value);
        const schedule = Object.assign({}, newschedule, { time });
        const weekdays = getWeekedays(schedule.scheduleWeekDays);

        this.Events.emit(this.routeScheduleEvent, {
          schedule,
          weekdays,
          corporateReservations,
          index,
        });
      }
    };

    this.Events.on(this.onUpdateTimeEvent, this.onUpdateTime.bind(this));
    this.Events.on(this.onUpdateLabelEvent, this.onUpdate.bind(this));
    this.Events.on(this.onUpdateActiveEvent, this.onUpdateActive.bind(this));

    this.Events.on(
      this.onUpdateBookOnTheFlyEvent,
      this.onUpdateBookOnTheFly.bind(this)
    );
    this.Events.on(
      this.onUpdateCaptainEvent,
      this.onUpdateAutoComplete.bind(this)
    );
    this.Events.on(this.onUpdateCaptainPriceEvent, this.onUpdate.bind(this));
    this.Events.on(this.onAddScheduleEvent, this.onAddScheduleError.bind(this));
    this.Events.on(
      this.onUpdateArrivalAllowanceEvent,
      this.onUpdateTimeInterval.bind(this)
    );
    this.Events.on(
      this.onUpdateDepartureAllowanceEvent,
      this.onUpdateTimeInterval.bind(this)
    );
    this.Events.on(this.onUpdateScheduleBufferEvent, this.onUpdate.bind(this));
    this.Events.on(
      this.onUpdateBustypeEvent,
      this.onUpdateAutoComplete.bind(this)
    );
    this.Events.on(this.onChangeBusTypeEvent, this.onChangeBusType.bind(this));
    this.Events.on(
      this.onChangeRideCategoryEvent,
      this.onChangeRideCategory.bind(this)
    );
    this.Events.on(
      this.onChangeCorporateEvent,
      this.onChangeCorporate.bind(this)
    );
    this.Events.on(this.onUpdatePricingConf, this.updatePricingConf.bind(this));
    this.Events.on(this.onResetPricingConf, this.resetPricingConf.bind(this));
    this.Events.on(
      this.onFollowCityForNewSchedules,
      this.followCityForNewSchedules.bind(this)
    );
    this.Events.on(
      this.routeScheduleEvent,
      this.onRouteScheduleEdit.bind(this)
    );
  }

  toggleManualEstimatesEdit(schedule) {
    schedule.isManualEstimatesEditable.value = !schedule
      .isManualEstimatesEditable.value;
  }

  getItemIdx(itemId, items) {
    const checkIndex = (item) => item._id.value === itemId;

    return findIndex(checkIndex)(items);
  }

  onUpdateTime(item) {
    const id = item.extraParams._id.value;
    const key = item.name;
    const localTimezone =
      new Date().getTimezoneOffset() * constants.fromMinToMilli * -1;
    // Difference between local timezone and route city timezone
    const diffTimezone = Math.abs(this.route.city.timezone - localTimezone);

    // Get Selected Time with respect of timezone
    const valueWithDiffTimezone =
      localTimezone > this.route.city.timezone
        ? getTime(item.value) - diffTimezone
        : getTime(item.value) + diffTimezone;

    /* Local timezone and route city timezone are the same, will send selected value
    // Local timezone and route city timezone aren't the same, will respect local timezone
    // handle if difference timezone is negative so need to add 24 hours
    */
    const value =
      this.route.city.timezone === localTimezone ||
      Math.abs(this.route.city.timezone) === localTimezone
        ? getTime(item.value)
        : valueWithDiffTimezone < 0
        ? valueWithDiffTimezone + constants.fromDayToMilli
        : valueWithDiffTimezone < constants.fromDayToMilli
        ? valueWithDiffTimezone
        : valueWithDiffTimezone - constants.fromDayToMilli;

    const name = item.methodName;
    const param = {
      [key]: value,
    };
    const itemIdx = this.getItemIdx(id, this.schedules);
    this.onUpdateItem(id, name, param).then(
      (response) => {
        // Justify schedule after update scheduleStartTime to display estimates correctly.
        this.schedules[itemIdx] = this.RouteTransforms.justifySchedule(
          [{ _id: response._id, _source: response }],
          this.route.city.timezone
        )[0];

        this.Events.emit(
          this.showNotificationEvent,
          this.Messages.updateMessage("stations")
        );

        this.schedules[itemIdx].time.isDisabled = true;
      },
      (response) => {
        if (response.data.captainConflict) {
          const captainConflict = response.data.captainConflict;
          this.showConflictDialog(captainConflict);
        }
        this.Events.emit(this.errorEvent, response.data);
      }
    );
  }

  onUpdateTimeInterval(item) {
    const id = item.extraParams._id.value;
    const key = item.key;
    const value = item.value * constants.fromMinToMilli;
    const name = item.methodName;
    const param = {
      [key]: value,
    };

    this.onUpdateItem(id, name, param).then(
      () => {
        this.Events.emit(
          this.showNotificationEvent,
          this.Messages.updateMessage("stations")
        );
        const itemIdx = this.getItemIdx(id, this.schedules);

        this.schedules[itemIdx][key].isDisabled = true;
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }

  onAddScheduleError({ index, response }) {
    this.schedules[index].isDisabled = false;
    if (response.data.captainConflict) {
      const captainConflict = response.data.captainConflict;
      this.showConflictDialog(captainConflict);
    }
  }

  onUpdateActive(item) {
    const id = item.extraParams._id.value;
    const key = item.name;
    const value = item.value;
    const name = value ? "activate" : "deactivate";
    const param = {
      [key]: value,
    };
    const itemIdx = this.getItemIdx(id, this.schedules);
    if (
      item.extraParams.is_manual_eta.value &&
      item.extraParams.manual_estimates.length === 0
    ) {
      this.Events.emit(this.errorEvent, {
        message: "Schedule manual estimates must have values",
      });
      return;
    }
    this.onUpdateItem(id, name, param).then(
      () => {
        this.Events.emit(
          this.showNotificationEvent,
          this.Messages.updateMessage("Active/ Inactive")
        );
        this.schedules[itemIdx][key].isDisabled = true;
      },
      (response) => {
        if (response.data.captainConflict) {
          const captainConflict = response.data.captainConflict;
          this.showConflictDialog(captainConflict);
        }
        this.Events.emit(this.errorEvent, response.data);
      }
    );
  }

  onUpdateManualEstimates(item) {
    const id = item._id.value;
    const itemIdx = this.getItemIdx(id, this.schedules);
    const scheduleManualEstimates = this.schedules[itemIdx].manual_estimates;
    // Get schedule time to calculate arrival and departure
    const scheduleTime = getTime(this.schedules[itemIdx].time.value);
    // Calculate the difference between arrival, departure and schedule start time to send them in request body
    const getTimeDiff = (time) => {
      if (getTime(time) < scheduleTime) {
        return constants.fromDayToMilli - scheduleTime + getTime(time);
      }
      return getTime(time) - scheduleTime;
    };

    // In case of resetting
    if (isNil(first(scheduleManualEstimates).station)) {
      first(scheduleManualEstimates).arrival = 0;
      scheduleManualEstimates.forEach((element, index) => {
        element.station = this.route.stations[index]._id;
      });
    }

    const formatManualETAs = scheduleManualEstimates.map(
      ({ arrival, departure, station }, index) => ({
        arrival: index ? getTimeDiff(arrival.value) : 0,
        departure: getTimeDiff(departure.value),
        station: station.value ? station.value : station,
      })
    );
    this.Schedule.patchAction(
      id,
      {
        manual_estimates: formatManualETAs,
      },
      "update_manual_estimates"
    ).$promise.then(
      (response) => {
        this.Events.emit(this.showNotificationEvent, {
          message: "Schedule Manual Estimates updated successfully",
        });
        this.schedules[itemIdx].isManualEstimatesEditable.value = false;
        // Justify schedule after update manual estimates to display estimates correctly.
        this.schedules[itemIdx] = this.RouteTransforms.justifySchedule(
          [{ _id: response._id, _source: response }],
          this.route.city.timezone
        )[0];
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }

  onUpdateBookOnTheFly(item) {
    const id = item.extraParams._id.value;
    const key = item.name;
    const value = item.value;
    const name = "update_ride_booking_method";
    const param = {
      [key]: value ? "on_the_fly" : "regular",
    };

    this.onUpdateItem(id, name, param).then(
      () => {
        this.Events.emit(
          this.showNotificationEvent,
          this.Messages.updateMessage("stations")
        );

        const itemIdx = this.getItemIdx(id, this.schedules);
        const toBeDisabledKey = "must_book_on_the_fly";
        this.schedules[itemIdx][toBeDisabledKey].isDisabled = true;
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }

  saveReservations(scheduleId, isActive, corporateReservations, scheduleIndex) {
    const {
      corporate,
      ride_price: ridePrice,
      supply_cost: supplyCost,
    } = corporateReservations;
    this.Reservation.post({
      schedule: scheduleId,
      corporate,
      ride_price: ridePrice || undefined,
      supply_cost: supplyCost || undefined,
    }).$promise.then(
      (response) => {
        this.schedules[scheduleIndex].corporate_reservation = response._id;
        this.schedules[scheduleIndex].corporate.isDisabled = true;
        this.schedules[scheduleIndex].ride_category.isDisabled = true;
        this.Events.emit(this.showNotificationEvent, {
          message: "Corporate reservation created successfully",
        });
        if (isActive && scheduleId) {
          this.Schedule.updateAction(scheduleId, "activate", {
            active: isActive,
          }).$promise.then(
            () => {},
            (res) => this.Events.emit(this.errorEvent, res.data)
          );
        }
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }

  onRouteScheduleEdit(options) {
    const schedule = this.reverseJustifySchedule(options.schedule);
    const weekdays = options.weekdays;
    const data = assign(schedule, { weekdays });

    // Add Stations Ids for Manual Estimates
    if (data.manual_estimates) {
      data.manual_estimates.length
        ? data.manual_estimates.forEach((element, index) => {
            element.station = this.route.stations[index]._id;
          })
        : delete data.manual_estimates;
    }

    /* Save active business schedule specification.
        business logic I don't own it. I don't have control on it.
        sorry for the bad code!
        the scenario is :
          - if isActive === true then it should first save the schedule
          with negating the active status to false then
          save the schedule > save the corporate reservation > update active status to true sequentially
          - if isActive === false then the normal schedule creation behavior works.
      */
    if (schedule._id) {
      this.Schedule.update(schedule._id, data).$promise.then(
        () => {
          this.Events.emit(
            this.showNotificationEvent,
            this.Messages.updateMessage("schedules")
          );
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    } else {
      data.route = this.$stateParams.id;
      const isActive = schedule.active;
      if (options.schedule.pricingVersionValue === "fixed" && isActive) {
        data.active = false;
      }
      this.Schedule.post(data).$promise.then(
        (response) => {
          const thisSchedule = this.schedules[options.index];
          thisSchedule._id = {
            value: response._id,
          };
          thisSchedule.predicted_end_time = moment();
          this.newSchedulePredictedEndTime = response.predicted_end_time;
          this.justifyNewSchedule(thisSchedule);
          thisSchedule.hideEdit = false;
          thisSchedule.isManualEstimatesEditable.value = false;
          thisSchedule.isDisabled = true;
          const scheduleId = response._id;
          if (
            !isNil(schedule) &&
            options.schedule.pricingVersionValue === "fixed" &&
            !isNil(options.corporateReservations) &&
            !isNil(options.corporateReservations.corporate)
          ) {
            this.saveReservations(
              scheduleId,
              isActive,
              options.corporateReservations,
              options.index
            );
          }
          this.Events.emit(
            this.showNotificationEvent,
            this.Messages.addMessage("schedule")
          );
        },
        (response) => {
          this.Events.emit(this.errorEvent, response.data);
          this.Events.emit(this.onAddScheduleEvent, {
            index: options.index,
            response,
          });
        }
      );
    }
  }

  justifyNewSchedule(schedule) {
    forIn((value) => {
      if (has("isDisabled")(value)) value.isDisabled = true;
    })(schedule);

    schedule.ride_category.isDisabled = true;
    schedule.arrival_time_allowance = schedule.arrival_time_allowance || {};
    schedule.arrival_time_allowance.isDisabled = true;

    schedule.departure_time_allowance = schedule.departure_time_allowance || {};
    schedule.departure_time_allowance.isDisabled = true;

    schedule.must_book_on_the_fly = schedule.must_book_on_the_fly || {};
    schedule.must_book_on_the_fly.isDisabled = true;
    const localTimezone =
      new Date().getTimezoneOffset() * constants.fromMinToMilli;

    if (this.route.city.timezone > 0) {
      schedule.predicted_end_time = {
        isDisabled: true,
        value: moment()
          .startOf("day")
          .add(
            this.newSchedulePredictedEndTime -
              this.route.city.timezone -
              localTimezone
          )
          .format(constants.timeFormat),
      };
    } else {
      schedule.predicted_end_time = {
        isDisabled: true,
        value: moment()
          .startOf("day")
          .add(
            this.newSchedulePredictedEndTime +
              Math.abs(this.route.city.timezone) -
              localTimezone
          )
          .format(constants.timeFormat),
      };
    }
    // For adding isDisable for each manual estimates item after schedule creation
    schedule.manual_estimates.map((element) => {
      return toObject(element);
    });
  }

  togglePricingConfEditing(schedule) {
    schedule.isPricingConfEditable = !schedule.isPricingConfEditable;
  }

  updatePricingConf(data) {
    const { schedule, index } = data;

    let {
      base_fare,
      distance_bucket_fare,
      distance_bucket_size,
      time_bucket_fare,
      time_bucket_size,
      base_time,
      base_distance,
    } = schedule.pricing_parameters;
    // Multiplying fares by 100
    base_fare = multiplyFloatingPointByCurrency(base_fare);
    distance_bucket_fare = multiplyFloatingPointByCurrency(
      distance_bucket_fare
    );
    time_bucket_fare = multiplyFloatingPointByCurrency(time_bucket_fare);
    const pricing_parameters = {
      base_fare,
      distance_bucket_fare,
      distance_bucket_size,
      time_bucket_fare,
      time_bucket_size,
      base_time,
      base_distance,
    };
    // If not new schedule
    if (!schedule.hideEdit) {
      this.Schedule.patchAction(
        schedule._id.value,
        pricing_parameters,
        "update_pricing_parameters"
      ).$promise.then(
        (response) => {
          this.schedules[index] = this.RouteTransforms.justifySchedule(
            [{ _id: response._id, _source: response }],
            this.route.city.timezone
          )[0];
          schedule.isPricingConfEditable = false;
          this.Events.emit(this.showNotificationEvent, {
            message: "Schedule Pricing Config updated successfully",
          });
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    } else {
      schedule.isPricingConfEditable = false;
      if (this.resetScheduleParams) {
        schedule.pricing_parameters = this.pricingParams;
        schedule.new_schedule_customized_pricing_params = false;
        this.resetScheduleParams = false;
      } else {
        schedule.new_schedule_customized_pricing_params = true;
      }
    }
  }

  followCityForNewSchedules(data) {
    this.resetScheduleParams = true;
    this.updatePricingConf(data);
  }
  resetPricingConf(data) {
    const { schedule, index } = data;
    this.Schedule.resetPricingParameters(schedule._id.value).$promise.then(
      (response) => {
        this.schedules[index] = this.RouteTransforms.justifySchedule(
          [{ _id: response._id, _source: response }],
          this.route.city.timezone
        )[0];
        this.isPricingConfEditable = false;
        this.Events.emit(this.showNotificationEvent, {
          message:
            "Schedule Pricing Config Set To Default City Pricing Configuration Successfully",
        });
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }
  onUpdate(item) {
    const id = item.extraParams._id.value;
    const key = item.key;
    const value = item.value;
    const name = item.methodName;
    const param = {
      [key]: value,
    };

    this.onUpdateItem(id, name, param).then(
      () => {
        this.Events.emit(
          this.showNotificationEvent,
          this.Messages.updateMessage("stations")
        );
        const itemIdx = this.getItemIdx(id, this.schedules);

        this.schedules[itemIdx][key].isDisabled = true;
      },
      (response) => {
        if (response.data.captainConflict) {
          const captainConflict = response.data.captainConflict;
          this.showConflictDialog(captainConflict);
        }

        this.Events.emit(this.errorEvent, response.data);
      }
    );
  }

  onUpdateAutoComplete(item) {
    const schedule = item.extraParams;
    const id = schedule._id.value;
    const key = item.key;

    const value = item.name
      ? isObject(item.name)
        ? item.name._id
        : item._id
      : null;

    const name = item.methodName;
    const param = {
      [key]: value,
    };

    this.onUpdateItem(id, name, param).then(
      () => {
        this.Events.emit(this.showNotificationEvent, {
          message: "Schedule was updated successfully",
        });
        const itemIdx = this.getItemIdx(id, this.schedules);

        this.schedules[itemIdx][key].isDisabled = true;
        if (key === "bus_type") {
          this.Events.emit(this.updateReservationEvent, {
            id: schedule.corporate_reservation,
            ridePrice: !isNil(schedule.ride_price.value)
              ? schedule.ride_price.value * constants.currencyBy
              : null,
            supplyCost: !isNil(schedule.supply_cost.value)
              ? schedule.supply_cost.value * constants.currencyBy
              : null,
          });
        }
      },
      (response) => {
        if (response.data.captainConflict) {
          const captainConflict = response.data.captainConflict;
          this.showConflictDialog(captainConflict);
        }
        this.Events.emit(this.errorEvent, response.data);
      }
    );
  }

  onUpdateItem(id, name, param) {
    return this.Schedule.updateAction(id, name, param).$promise;
  }

  isCityPermitted() {
    const permittedCities = [
      {
        name: "Cairo",
        id: "58d1560b2207c00001aabc9a",
      },
      {
        name: "Alexandria",
        id: "5947b64eb17fa400018ed437",
      },
    ];

    return permittedCities.some((city) => this.route.city._id === city.id);
  }

  refreshPet(schedule) {
    const scheduleId = schedule._id.value;

    this.Schedule.refreshPet(scheduleId).$promise.then(
      (response) => {
        const itemIdx = this.getItemIdx(scheduleId, this.schedules);
        this.schedules[itemIdx].predicted_end_time.value = moment(
          response.predicted_end_time - this.route.city.timezone
        );

        this.Events.emit(
          this.showNotificationEvent,
          this.Messages.updateMessage("PET")
        );
      },
      (response) => {
        if (response.data.captainConflict) {
          const captainConflict = response.data.captainConflict;
          this.showConflictDialog(captainConflict);
        }
        this.Events.emit(this.errorEvent, response.data);
      }
    );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/editableSchedules/editableSchedules.controller.js